import React from "react";

// intl imports
import { useIntl, FormattedNumber } from "react-intl";

import { TableCell, TableRow } from "@material-ui/core";

import { getLocalizedNameWithIntl } from "../../globals/langHelpers";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    winterPremiumStyles: {
        color: "#0075FF",
        fontSize: 14,
        fontFamily: "Arial",
    },
}));
const WinterPremium = (props) => {
    const classes = useStyles();
    const row = props.row;
    const intl = useIntl();
    const winterCost = props.winterCost;
    const winterQuantity = props.winterQuantity;

    return (
        <TableRow>
            <TableCell align="left" className={classes.winterPremiumStyles}>
                {`${row.productCode}*`}
            </TableCell>
            <TableCell align="left" className={classes.winterPremiumStyles}>
                {getLocalizedNameWithIntl(intl, { object: row, value: "productDescription" })}
            </TableCell>
            <TableCell align="left" className={classes.winterPremiumStyles}></TableCell>
            <TableCell align="left" className={classes.winterPremiumStyles}>
                {row.additionalDetails}
            </TableCell>
            <TableCell align="right" className={classes.winterPremiumStyles}>
                <FormattedNumber value={winterQuantity} style="decimal" />
            </TableCell>
            <TableCell align="right" className={classes.winterPremiumStyles}>
                {"$"}
            </TableCell>
            <TableCell align="right" className={classes.winterPremiumStyles}>
                {row.price * 100}
                {"%"}
            </TableCell>
            <TableCell align="right" className={classes.winterPremiumStyles}>
                <FormattedNumber value={winterCost} style="currency" currency="CAD" currencyDisplay="narrowSymbol" />
            </TableCell>
        </TableRow>
    );
};

export default WinterPremium;
